"use client";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useState } from "react";
import { Collapse } from "@/utils/bootstrap";
import PhoneNumbersPopup from "./phone-numbers-popup/PhoneNumbersPopup";
import SvgFabExpand from "./fab-icons/SvgFabExpand";
import SvgFabPhone from "./fab-icons/SvgFabPhone";
import NextImage from "@/app/components/lib/NextImage";
import { usePathname } from "next/navigation";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { useRemoveLangFromPath } from "@/hooks/useRemoveLangFromPath";
import useIsClient from "@/hooks/useIsClient";

const Fab = () => {
  const [expand, setExpand] = useState(false);
  const [showPhone, setShowPhone] = useState(false);
  const removeLangFromPath = useRemoveLangFromPath();
  const getCompany = useGetCompanyQuery();
  const isClient = useIsClient();
  const company = getCompany?.data?.result;
  const contacts = company?.contacts;
  const enable_direct_calls = company?.theme?.settings?.enable_direct_calls;
  const pathname = usePathname();
  const currPath = removeLangFromPath(pathname, true);
  const showFab = ["/"]?.includes(currPath! as PagesPaths);

  if (
    !company?.theme?.settings?.enable_floating_social_icons ||
    !showFab ||
    !isClient
  )
    return null;
  return (
    <>
      {showPhone && (
        <PhoneNumbersPopup
          show={showPhone}
          setShow={setShowPhone}
          phoneNumbers={contacts?.phones ?? []}
        />
      )}
      <div className="fab-container">
        <Collapse in={expand} dimension={"height"}>
          <div>
            <div className="fab-btns">
              {contacts?.social_media?.map((s, key) => (
                <div key={key} className="fab-btn">
                  <a target="_blank" href={s?.url} rel="noopener noreferrer">
                    <NextImage
                      objectFit="fill"
                      alt="contact"
                      src={s?.icon}
                      width={48}
                      height={48}
                    />
                  </a>
                </div>
              ))}
              {enable_direct_calls &&
                contacts &&
                contacts?.phones?.length > 0 && (
                  <SvgFabPhone onClick={() => setShowPhone(true)} />
                )}
            </div>
          </div>
        </Collapse>
        <div
          className={`fab-icon ${expand ? "rotate" : ""}`}
          tabIndex={0}
          onClick={() => setExpand(!expand)}
          onBlur={() => setTimeout(() => setExpand(false), 300)}
        >
          <SvgFabExpand />
        </div>
      </div>
    </>
  );
};

export default Fab;
